export default __webpack_public_path__ + "media/images/memorialday/MemorialDayFlagMobile.jpg";